import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import httpService from "../../../services/httpService";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import LoadingFade from "../../LoadingFade";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import { FaRegCircleCheck } from "react-icons/fa6";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Collapse from "react-bootstrap/esm/Collapse";
import { FaSpinner } from "react-icons/fa6";
import {FaEject, FaFolderMinus, FaFolderPlus, FaPlayCircle, FaSearch} from "react-icons/fa";
import {Modal} from "react-bootstrap";

const StepClubEpisodes = ({ onStageChange, onClubChange, podcastClub }) => {
    const { step, id } = useParams();
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [podcast, setPodcast] = useState(null);
    const [episodes, setEpisodes] = useState([]);
    const [openInfo, setOpenInfo] = useState(false);
    const [rssFeedString, setRssFeedString] = useState("");
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const [savedEpisodes, setSavedEpisodes] = useState(0);
    const [searchString, setSearchString] = useState("");
    const [isWizardCompleted, setIsWizardCompleted] = useState(false);

    const [podcastClubErrors, setPodcastClubErrors] = useState({});
    const [clubEpisodes, setClubEpisodes] = useState([]);
    const [removingEpisode, setRemovingEpisode] = useState(null);
    const [savingEpisode, setSavingEpisode] = useState(null);
    const [openDescriptions, setOpenDescriptions] = useState({});
    const [showVideoModal, setShowVideoModal] = useState(false);

    useEffect(() => {
        let endpoint_with_params = "/dash/wizard/get-step/3"+ (id ? "/"+id : "") + (!id && podcastClub ? "/"+podcastClub.guid : '')
        httpService.get(endpoint_with_params)
            .then((res) => {
                getPodcastClubEpisodes()
                setIsWizardCompleted(res.data.is_wizard_completed)
            })
            .catch((err) => {
                setErrorMessage(err.response?.data?.message || "Error loading data");
            }).finally(() => {
            console.log(podcastClub)
            setLoading(false);
        });
    }, []);


    const handleChange = (e) => {
        setRssFeedString(e.target.value)
    }
    const handleSearchChange = (e) => {
        setSearchString(e.target.value)
    }
    const searchByString = (e) => {
        e.preventDefault()
        if(searchString === ""){
            setEpisodes(podcast.items)
        }
        const newEpisodes = podcast.items.filter((item) => {
            let title = item.title.toLowerCase()
            let string = searchString.toLowerCase()
            return title.includes(string)
        });
        setEpisodes(newEpisodes)
    }

    const handleSubmit = async (e) => {
        setLoading(true)
        // alert(rssFeedString)
        try {
            const res = await httpService.get("dash/wizard/rss/"+ btoa(rssFeedString));
            // const res = {
            //     data : data
            // };
            console.log("parsed:", res.data);
            const savedCount = res.data.items.filter(ep => ep.saved).length;
            setSavedEpisodes(savedCount)
            setPodcast(res.data)
            setEpisodes(res.data.items)
            setErrorMessage('')
        } catch (err) {
            setErrorMessage(err.message)
        } finally {
            setLoading(false)
        }
    };

    const handleEpisodeSaved = async () => {
        await getPodcastClubEpisodes()
    };

    const goToNextStep = async () => {

        try {

        } catch (err) {
            setErrorMessage(err.message)
        } finally {
            setLoading(false)
            setPageLoading(true)
            onStageChange(4)
        }
    };

    const goToClubDashboard = () => {
        setPageLoading(true)
        navigate(`/podcaster/podcast-club/${podcastClub.guid}`)
    };

    const handleSaveEpisode = async (episode) => {
        setSavingEpisode(episode.guid);
        try {
            const res = await httpService.post(`dash/club/${id}/episodes`, { ...episode, podcastClubGuid: id });
            if (res.data.status) {
                setEpisodes(prev => prev.map(e => e.guid === episode.guid ? { ...e, saved: true } : e));
                await getPodcastClubEpisodes();
            }
        } catch (err) {
            setErrorMessage(err.message);
        } finally {
            setSavingEpisode(null);
        }
    };

    const handleRemoveEpisode = async (episodeGuid) => {
        setRemovingEpisode(episodeGuid);
        try {
            const res = await httpService.delete(`dash/club/${id}/episodes/${episodeGuid}`);
            if (res.data.status === true) {
                await getPodcastClubEpisodes();
            }
        } catch (err) {
            setErrorMessage(err.message);
        } finally {
            setRemovingEpisode(null);
        }
    };

    const getPodcastClubEpisodes = async () => {
        try {
            const res = await httpService.get("dash/club/"+id+'/episodes');
            console.log("parsed:", res.data);
            setClubEpisodes(res.data.episodes)
        } catch (err) {
            setPodcastClubErrors({...err.response.data.errors})
        } finally {

        }
    };


    return(
        <LoadingFade className={'component-StepClubEpisodes'} loading={pageLoading} stateKey={pageLoading?'loading':'not-loading'}>
            <Row className={'pb-3'}>
                <Col sm={12}>
                    <h3>Add your podcast feed</h3>
                    <p className="mb-1">Paste your RSS feed link to load your episodes. <br/>We'll automatically pull in your episode titles, descriptions, artwork, and audio. You just paste the link.</p>
                    <p className="text-muted small">You'll set the release order for these on the Schedule step.</p>
                    <div className="wizard-help">
                        <p className="wizard-help__lead">How adding episodes works.</p>
                        <button type="button" className="wizard-help-btn" onClick={() => setShowVideoModal(true)}>
                            <FaPlayCircle aria-hidden="true" /> Watch the video
                        </button>
                    </div>
                </Col>
                <Col sm={12}>
                    {clubEpisodes.map((epi) => (
                        <Card key={epi.guid} style={{ borderLeft: '10px solid ' + epi.pivot.color }} className="p-3 mb-3 episode-card select">
                            <Row>
                                <Col sm={11}>
                                    <p>{epi.title}</p>
                                </Col>
                                <Col sm={1} className={'text-end'}>
                                    <OverlayTrigger
                                        placement="left"
                                        overlay={<Tooltip>Remove this episode from podcast club</Tooltip>}
                                    >
                                        <Button
                                            onClick={() => handleRemoveEpisode(epi.guid)}
                                            disabled={removingEpisode === epi.guid}
                                            className="text-white"
                                            variant="danger"
                                            size="sm"
                                        >
                                            {removingEpisode === epi.guid ? <FaSpinner className="loading_spinner" /> : <FaFolderMinus />}
                                        </Button>
                                    </OverlayTrigger>
                                </Col>
                            </Row>
                        </Card>
                    ))}
                </Col>
                <Col sm={4} className={'mb-3'}>
                    <label className={'mb-2'}>Go to skills</label>
                    <button
                        className={"btn btn-light btn-block w-100"}
                        onClick={() => onStageChange(2, id)}
                    >
                        Back
                    </button>
                </Col>
                <Col sm={4} className={'mb-3'}>
                    {isWizardCompleted ? (
                        <div>
                            <label className={'mb-2'}>Go to dashboard</label>
                            <Button
                                disabled={!(podcastClub.title && podcastClub.description)}
                                variant={'primary'}
                                className={'primary w-100'}
                                onClick={goToClubDashboard}>
                                Back to club dashboard
                            </Button>
                        </div>
                    ):''}
                </Col>
                <Col sm={4} className={"mb-3"}>
                    <label className={'mb-2'}>You'll review insights episode by episode</label>
                    <Button
                        onClick={()=>onStageChange(4, id)}
                        disabled={clubEpisodes.length < 3}
                        className="w-100"
                        variant={isWizardCompleted ? 'light' : 'primary'}
                    >
                        Set key takeaways
                    </Button>
                </Col>
                <Col sm={12}>
                    <hr/>
                </Col>
                <Col sm={12}>
                  <div className="wizard-box">
                    <Row>
                <Col sm={9} className="d-flex flex-column justify-content-end">
                    <Form.Group className="" controlId="rssFeedString">
                        <Form.Label>
                            RSS feed URL <span className="text-muted fw-normal">— Paste your feed link and Podsy reads it to load your episodes into the list below. Nothing on your end changes; your feed isn't touched.</span>
                        </Form.Label>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip id="button-tooltip">
                                    Paste RSS URL into this input
                                </Tooltip>
                            }
                        >
                            <Form.Control
                                name={'rssFeedString'}
                                type="text"
                                placeholder="https://…"
                                onChange={handleChange}
                                isInvalid={!!errorMessage}
                                disabled={loading}
                                className={'mb-3'}
                            />
                        </OverlayTrigger>
                        <Form.Control.Feedback type="invalid">
                            {errorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col sm={3} className="d-flex flex-column justify-content-end">
                    <Form.Label>Submit</Form.Label>
                    <Button disabled={loading || !rssFeedString} onClick={handleSubmit} className="w-100 mb-3" variant="light" type="submit">
                        {podcast ? "Load another Episodes" : "Load episodes"}
                    </Button>
                </Col>
                <Col sm={12} className="mb-2">
                    <Button
                        variant="outline-primary"
                        className="fw-semibold"
                        aria-expanded={openInfo}
                        onClick={() => setOpenInfo(!openInfo)}>
                        <FaSearch className="me-2" aria-hidden="true" />Find my feed
                    </Button>
                    <span className="text-muted small ms-2">Don't have your RSS link handy?</span>
                </Col>
                    </Row>
                  </div>
                </Col>
                <Collapse in={openInfo}>
                    <Row>
                        <Col sm={12}>
                            <br/>
                            <p>Most hosts show it in your show settings. Look for “RSS feed”, “Feed”, or “Distribution”.</p>
                        </Col>
                        <Col sm={4}>
                            <div className={'text-center logo-image-wrapper'}>
                                <Image src={'/img/logos/captivate.png'} fluid/>
                            </div>
                            <h3>Captivate</h3>
                            <ul>
                                <li>Log in to <a href={'https://my.captivate.fm/login?returnUrl=%2Fdashboard%2Fstart'} target={'_blank'}>Captivate</a> </li>
                                <li>Open your podcast show</li>
                                <li>Go to Settings or Podcast Settings</li>
                                <li>Find RSS Feed</li>
                                <li>Copy the full link and paste it here</li>
                            </ul>
                        </Col>
                        <Col sm={4}>
                            <div className={'text-center logo-image-wrapper'}>
                                <Image src={'/img/logos/buzzsprout.png'} fluid/>
                            </div>
                            <h3>Buzzsprout</h3>
                            <ul>
                                <li>Log in to Buzzsprout</li>
                                <li>Open your podcast</li>
                                <li>Go to Directories</li>
                                <li>Find Your RSS Feed</li>
                                <li>Copy and paste it here</li>
                            </ul>
                        </Col>
                        <Col sm={4}>
                            <div className={'text-center logo-image-wrapper'}>
                                <Image src={'/img/logos/libsyn.png'} fluid/>
                            </div>
                            <h3>Libsyn</h3>
                            <ul>
                                <li>Log in to Libsyn</li>
                                <li>Go to Destinations (or Settings)</li>
                                <li>Find RSS Feed</li>
                                <li>Copy and paste it here</li>
                            </ul>
                        </Col>
                        <Col sm={4}>
                            <div className={'text-center logo-image-wrapper'}>
                                <Image src={'/img/logos/spotify.png'} fluid/>
                            </div>
                            <h3>Spotify for Podcasters</h3>
                            <ul>
                                <li>Log in to Spotify for Podcasters</li>
                                <li>Select your show</li>
                                <li>Go to Settings</li>
                                <li>Look for RSS feed</li>
                                <li>Copy and paste it here</li>
                            </ul>
                        </Col>
                        <Col sm={4}>
                            <div className={'text-center logo-image-wrapper'}>
                                <Image src={'/img/logos/podbean.png'} fluid/>
                            </div>
                            <h3>Podbean</h3>
                            <ul>
                                <li>Log in to Podbean</li>
                                <li>Go to Settings</li>
                                <li>Find Feed / RSS Feed</li>
                                <li>Copy and paste it here</li>
                            </ul>
                        </Col>
                        <Col sm={4}></Col>
                    </Row>
                </Collapse>
            </Row>
            <LoadingFade loading={loading} stateKey={loading?'loading':'not-loading'}>
                {podcast ?
                    <Row className={"mb-3"}>
                        <Col sm={12} className={"mb-3"}>
                            <Form.Group className="" controlId="podcastTitle">
                                <Form.Label>Podcast title</Form.Label>
                                <Form.Control
                                    name={'podcastTitle'}
                                    type="text"
                                    placeholder="Club title"
                                    value={podcast.title}
                                    isInvalid={!!errorMessage}
                                    disabled={true}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errorMessage}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        {/*<Col sm={12}>*/}
                        {/*    <Row>*/}
                        {/*        <Col sm={10}>*/}
                        {/*            <p>*/}
                        {/*                {podcast.description}*/}
                        {/*            </p>*/}
                        {/*        </Col>*/}
                        {/*        <Col sm={2} className={'text-center'}>*/}
                        {/*            {podcast.image ? (*/}
                        {/*                    <Image*/}
                        {/*                        src={podcast.image}*/}
                        {/*                        alt={podcast.title}*/}
                        {/*                        width={96}*/}
                        {/*                        height={96}*/}
                        {/*                        style={{ objectFit: "cover", borderRadius: 8 }}*/}
                        {/*                        loading="lazy"*/}
                        {/*                    />*/}
                        {/*                ) :*/}
                        {/*                <Image src={"/img/podsy-logo-w-200.png"} fluid className={"m-auto w-50"} />*/}
                        {/*            }*/}
                        {/*        </Col>*/}
                        {/*    </Row>*/}
                        {/*</Col>*/}
                        <Col sm={12}>
                            <Form className={'row'}>
                                <Col sm={9} className="mb-3">
                                    <Form.Group className="" controlId="searchEpisodes">
                                        <Form.Label>Search Episodes</Form.Label>
                                        <Form.Control
                                            name={'searchString'}
                                            type="text"
                                            value={searchString}
                                            placeholder="Type text to filter episodes"
                                            onChange={handleSearchChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={3} className="mb-3">
                                    <Form.Label>Submit</Form.Label>
                                    <Button onClick={searchByString} className="w-100" variant="light" type="submit">
                                        Search
                                    </Button>
                                </Col>
                            </Form>
                        </Col>
                        {episodes.map((it) => (
                            <Col sm={12} key={it.guid || it.link} className="">
                                <Card className={`p-3 mb-3 episode-card ${it.saved ? 'd-none' : ''}`}>
                                    <Row>
                                        <Col sm={9}>
                                            <Row>
                                                <Col sm={10}>
                                                    <div><small>{it.pub_date}</small></div>
                                                    <h5>{it.title}</h5>
                                                    <a onClick={() => setOpenDescriptions(prev => ({ ...prev, [it.guid]: !prev[it.guid] }))} className="w-100 text-secondary collapse-info">
                                                        Read this episode description
                                                    </a>
                                                </Col>
                                                <Col sm={2} className={'d-flex align-items-center'}>
                                                    <div className="text-center align-content-center">
                                                        <Image src={it.image} alt={it.title} width={48} height={48} style={{ objectFit: 'cover', borderRadius: 8 }} loading="lazy" />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col sm={3} className={'d-flex flex-column align-items-end justify-content-center'}>
                                            <Form.Label className="text-end">Add this episode to your podcast club</Form.Label>
                                            <Button onClick={() => handleSaveEpisode(it)}
                                                    disabled={savingEpisode === it.guid}
                                                    className="text-white"
                                                    variant="success"
                                                    size="md">
                                                {savingEpisode === it.guid ? <FaSpinner className="loading_spinner" /> : <FaFolderPlus />}
                                            </Button>
                                        </Col>
                                        <Col sm={12}>
                                            <Collapse in={!!openDescriptions[it.guid]}>
                                                <div dangerouslySetInnerHTML={{ __html: it.description }} />
                                            </Collapse>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        ))}
                        <Col sm={4} className={'mb-3'}>
                            <label className={'mb-2'}>Go to Skills</label>
                            <button
                                className={"btn btn-light btn-block w-100"}
                                onClick={() => onStageChange(2, id)}
                            >
                                Back
                            </button>
                        </Col>
                        <Col sm={4} className={'mb-3'}>
                            {isWizardCompleted ? (
                                <div>
                                    <label className={'mb-2'}>Go dashboard</label>
                                    <Button
                                        disabled={!(podcastClub.title && podcastClub.description)}
                                        variant={'primary'}
                                        className={'primary w-100'}
                                        onClick={goToClubDashboard}>
                                        Back to Club Dashboard
                                    </Button>
                                </div>
                            ):''}
                        </Col>
                        <Col sm={4} className={"mb-3"}>
                            <label className={'mb-2'}>You'll review insights episode by episode</label>
                            <Button onClick={()=>onStageChange(4, id)} className="w-100" variant="primary">
                                Continue
                            </Button>
                        </Col>
                    </Row>:""
                }
            </LoadingFade>

            <Modal show={showVideoModal} onHide={() => setShowVideoModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>How to add your podcast feed</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{position: 'relative', paddingBottom: '56.25%', height: 0}}>
                        <iframe
                            src="https://www.loom.com/embed/370785644cf2420290ff55dd513394d4"
                            frameBorder="0"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            allowFullScreen
                            style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </LoadingFade>
    )
}

export default StepClubEpisodes;